import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges,
} from '@angular/core';
import { IPotentialSavingsGraphDTO } from '@app/modules/potential-save-modal/dto/i-potential-savings-graph.dto';
import { renewalOverTimeConfig } from '@app/modules/potential-save-modal/renewal-over-time/renewal-over-time.config';
import { RenewalOverTimeService } from '@app/modules/potential-save-modal/renewal-over-time/renewal-over-time.service';
import { EChartsOption } from 'echarts';
import moment from 'moment';

@Component({
	selector: 'app-renewal-over-time',
	templateUrl: './renewal-over-time.component.html',
	styleUrls: ['./renewal-over-time.component.scss'],
	providers: [RenewalOverTimeService],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenewalOverTimeComponent implements OnChanges {
	@Output() public close: EventEmitter<void> = new EventEmitter();

	@Input()
	public set data(graphData: IPotentialSavingsGraphDTO) {
		if (!graphData) {
			return;
		}
		this._data = graphData;
	}

	@Input()
	public set dailySavings(value: number) {
		this._dailySavings = value;
	}

	@Input()
	public set startDate(value: string) {
		this._startDate = moment(value).add(1, 'day').format('YYYY-MM-DD');
	}

	private _data: IPotentialSavingsGraphDTO;
	private _dailySavings: number;
	private _startDate: string;

	public readonly title = 'Renewal over time';
	public readonly subtitle = 'This graph illustrates annual savings';

	public readonly chartOption: EChartsOption = renewalOverTimeConfig;
	public chartUpdateOptions: EChartsOption;

	constructor(private renewalOverTimeService: RenewalOverTimeService) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes.data?.currentValue && isFinite(changes.dailySavings?.currentValue) && changes.startDate?.currentValue) {
			this.runDataPreparation();
		}
	}

	private runDataPreparation(): void {
		if (this._data && isFinite(this._dailySavings) && this._startDate) {
			const data = this.renewalOverTimeService.prepareUpdatedChartOption(
				this._data,
				this._dailySavings,
				this._startDate,
			);
			this.chartUpdateOptions = { ...this.chartOption, ...data };
			this.chartUpdateOptions.tooltip = {
				...this.chartUpdateOptions.tooltip,
				...{ formatter: this.renewalOverTimeService.getFormatter() },
			};
		}
	}
}
